<template>
    <div id="Input">
        <div class="title" v-if="title">{{ title }}</div>
        <div @click="() => $emit('inputClicked')" class="container">
            <div class="left">
                <DynamicSvg v-if="firstIcon" :name="firstIcon" />
                <input :type="inputType" :placeholder="placeHolder" class="input" v-model="inputValue" />
                <div v-if="error" class="error-message">
                    <div class="err-container">{{ errorMessage }}</div>
                </div>
            </div>
            <div v-if="secondIcon" class="right">
                <DynamicSvg :name="secondIcon" :color="'#7A86A1'" />
            </div>
        </div>
    </div>
</template>
<script>
import DynamicSvg from "./DynamicSvg.vue";
export const enumInputType = Object.freeze({
    TEXT: "text",
    NUMBER: "number",
    PASSWORD: "password",
    EMAIL: "email",
});
export default {
    name: "Input",
    props: {
        firstIcon: { type: String, default: null },
        secondIcon: { type: String, default: null },
        color: { type: String, default: null },
        inputType: {
            validator(value) {
                if (Object.values(enumInputType).includes(value)) {
                    return value;
                }
            },
            default: enumInputType.TEXT,
        },
        placeHolder: { type: String, default: "" },
        error: { type: Boolean, default: false },
        errorMessage: { type: String, default: null },
        title: { type: String, default: null },
        value: { type: String, default: "" },
    },

    components: { DynamicSvg },
    data() {
        return {
            inputValue: this.value,
        };
    },
    methods: {},
    watch: {
        inputValue() {
            this.$emit("v-model", this.inputValue);
        },
    },
    mounted() {},
};
</script>
<style lang="scss" >
#Input {
    width: 100%;
    .title {
        color: #686868;
        font-size: 14px;
        font-weight: 400;
        line-height: 21px;
        margin-bottom: 10px;
    }
    .container {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        cursor: text;
        // Cerceveli kutu yerine dolgulu yuzey; odakta marka halkasi
        border: 1.5px solid transparent;
        background-color: var(--sps-field-bg, #f3f4f6);
        border-radius: var(--sps-radius-md);
        padding: 0 14px;
        min-height: 46px;
        transition: background-color 160ms ease, border-color 160ms ease, box-shadow 160ms ease;

        &:focus-within {
            background-color: #fff;
            border-color: var(--button-color);
            box-shadow: 0 0 0 3px rgba(15, 23, 42, 0.06);
        }

        input.input {
            flex: 1;
            min-width: 0;
            border: none;
            outline: none;
            background: transparent;
            font-family: inherit;
            font-size: 15px;
            color: var(--form-input-text);
        }

        // DynamicSvg ikonu bir sarmalayici div icinde veriyor; bosluk svg'ye
        // verilince sarmalayicinin fazla genisligi ustune biniyor ve ikon
        // metinden kopuyordu.
        .left > div {
            display: flex;
            align-items: center;
            flex-shrink: 0;
            width: auto;
            margin-right: 10px;
            line-height: 0;
        }

        svg {
            display: block;
            flex-shrink: 0;
            opacity: 0.5;
        }

        input.input::placeholder {
            color: var(--form-input-text);
            opacity: 0.42;
        }

        .left {
            display: flex;
            align-items: center;
            width: 100%;
            position: relative;
            .error-message {
                max-width: 213px;
                position: absolute;
                top: -50px;
                right: 0;
                color: white;
                background-color: var(--error-color);
                border-radius: var(--sps-radius-md);
                padding: 5px 11px;
                .err-container {
                    min-width: 100%;
                    min-height: 100%;
                    position: relative;
                    font-size: 17px;
                    font-weight: 500;
                    line-height: 24px;
                    z-index: 2;
                    &:after {
                        content: "\A";
                        border-style: solid;
                        border-width: 15px 18px 15px 0px;
                        border-color: transparent var(--error-color) transparent transparent;
                        position: absolute;
                        z-index: -1;
                        transform: rotate(270deg);
                        bottom: -24px;
                        left: calc(50% - 10px);
                    }
                }
            }
            .input {
                color: var(--form-input-label);
                border: none;
                outline: none;
                width: 100%;
                // Bosluk artik ikon sarmalayicisinda; burada da olunca ikon
                // metinden 20px uzakta kaliyordu.
                margin-left: 0;
                background-color: transparent !important;
                &::placeholder {
                    color: var(--form-input-label);
                    font-size: 14px;
                    font-weight: 500;
                    line-height: 17px;
                }
            }
        }
        .right {
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/common/Input.vue